<template>
  <div class="video-switch">
    <template v-if="done">
      <div
        v-if="!started"
        class="wrapper wrapper--auto"
      >
        <figure class="figure">
          <img
            alt=""
            draggable="false"
            class="poster"
            :src="require('@/assets/images/poster.jpg')"
          />
        </figure>
        <button
          class="play-button"
          @click="playVideos"
        >
          <PlayIcon class="play-icon"></PlayIcon>
        </button>
      </div>
      <div class="wrapper wrapper--normal">
        <video
          class="video video--normal"
          ref="vNom"
          :src="normalVideo"
          @ended="onPlayerEnded"
          preload="auto"
          playsinline
          disableRemotePlayback
          poster="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        >
          <p>Your browser doesn't support HTML5 video.</p>
        </video>
      </div>
      <div
        class="wrapper wrapper--depressed"
        :class="{
          'wrapper--hide': !corrupt
        }"
      >
        <video
          class="video video--depressed"
          ref="vDep"
          :src="depressedVideo"
          @ended="onPlayerEnded"
          preload="auto"
          playsinline
          disableRemotePlayback
          poster="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        >
          <p>Your browser doesn't support HTML5 video.</p>
        </video>
      </div>
      <div class="overlay"></div>
      <SwitchButton
        @toggle="switchMode"
        :depressed="corrupt"
      ></SwitchButton>
    </template>
    <template v-else>
      <div class="wrapper wrapper--fake"></div>
    </template>
  </div>
</template>

<script>
import media from '@/utils/media'
import { PlayIcon } from '@/components/icons'
import SwitchButton from './SwitchButton'
import { scrollPositionMixin, mediaQueryMixin, doneMixin } from '@/mixins'
import { trackVideo, trackSwitch } from '@/utils/track'

export default {
  name: 'VideoSwitch',
  data () {
    return {
      corrupt: false,
      started: false,
      tracked: false
    }
  },
  mixins: [scrollPositionMixin, mediaQueryMixin, doneMixin],
  methods: {
    playVideos () {
      // Switch to started
      this.started = true
      this.corrupt = false

      if (!this.tracked) {
        trackVideo('switch')
      }
      this.tracked = true

      // Get refs of both videos
      const vidNormal = this.$refs['vNom']
      const vidDepressed = this.$refs['vDep']

      // Mute depressed video
      vidNormal.muted = false
      vidDepressed.muted = true

      // Play both videos
      vidNormal.play()
      vidDepressed.play()
    },
    switchMode () {
      // Switch the mode
      this.corrupt = !this.corrupt
      const modeText = this.corrupt ? 'positivetonegative' : 'negativetopositive'
      trackSwitch(modeText)

      // Get refs of both videos
      const vidNormal = this.$refs['vNom']
      const vidDepressed = this.$refs['vDep']

      // Switch the muting
      vidNormal.muted = this.corrupt
      vidDepressed.muted = !this.corrupt
    },
    onPlayerEnded () {
      this.started = false
    },
    imgSize () {
      return this.mobile ? 'mobile' : 'desktop'
    }
  },
  watch: {
    inView () {
      if (!this.inView && this.started) {
        const vidNormal = this.$refs['vNom']
        const vidDepressed = this.$refs['vDep']
        // Pause both videos
        vidNormal.pause()
        vidDepressed.pause()
        // Set both videos to start
        vidNormal.currentTime = 0
        vidDepressed.currentTime = 0
        this.started = false
      }
    }
  },
  components: {
    PlayIcon,
    SwitchButton
  },
  computed: {
    normalVideo () {
      return media.videoSwitch.normal[this.imgSize()]
    },
    depressedVideo () {
      return media.videoSwitch.depressed[this.imgSize()]
    }
  }
}
</script>

<style lang="scss" scoped>
.video-switch {
  position: relative;
  width: 100%;
  margin: 20px auto 0;
  text-align: center;

  @media (min-width: 768px) {
    max-width: 500px;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba($c-red, 0.8);
  }
  70% {
    box-shadow: 0 0 0 25px rgba($c-red, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba($c-red, 0);
  }
}

.play-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: $c-red;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: none;
  box-shadow: 0 0 0 rgba($c-red, 0.8);
  animation: pulse 2s infinite;
  outline: 0;
  cursor: pointer;
  z-index: 40;
}
.play-icon {
  position: absolute;
  left: 30px;
  top: 25px;
}
.wrapper {
  position: relative;
  padding-bottom: 133.3333333333333%;
  font-size: 0;
  height: 0;

  &--normal {
    z-index: 10;
  }
  &--depressed {
    z-index: 20;
  }
  &--hide {
    visibility: hidden;
  }
  &--auto {
    z-index: 50;
  }
  &--auto, &--depressed {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  &--fake {
  }
}
.figure {
}
.poster {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.overlay {
  position: absolute;
  z-index: 40;
  bottom: 0;
  left: 0;
  right: 0;
  height: 200px;
  background-image: linear-gradient(to bottom, rgba(30, 30, 30, 0), rgba(30, 30, 30, 0.5),)
}
</style>



// WEBPACK FOOTER //
// src/components/switch/VideoSwitch.vue